import revive_payload_client_4sVQNw7RlN from "/home/binaffan.com/nuxt-frontend/node_modules/nuxt/dist/app/plugins/revive-payload.client.js";
import unhead_KgADcZ0jPj from "/home/binaffan.com/nuxt-frontend/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_jmwsqit4Rs from "/home/binaffan.com/nuxt-frontend/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import payload_client_yVLowv6hDl from "/home/binaffan.com/nuxt-frontend/node_modules/nuxt/dist/app/plugins/payload.client.js";
import navigation_repaint_client_bs2bWDGRIE from "/home/binaffan.com/nuxt-frontend/node_modules/nuxt/dist/app/plugins/navigation-repaint.client.js";
import check_outdated_build_client_8vK7RkfGxZ from "/home/binaffan.com/nuxt-frontend/node_modules/nuxt/dist/app/plugins/check-outdated-build.client.js";
import chunk_reload_client_UciE0i6zes from "/home/binaffan.com/nuxt-frontend/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
import plugin_vue3_YdLad5Mpq3 from "/home/binaffan.com/nuxt-frontend/node_modules/@pinia/nuxt/dist/runtime/plugin.vue3.js";
import components_plugin_KR1HBZs4kY from "/home/binaffan.com/nuxt-frontend/.nuxt/components.plugin.mjs";
import prefetch_client_5tzzN0oIVL from "/home/binaffan.com/nuxt-frontend/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import plugin_PSbK9A48ZQ from "/home/binaffan.com/nuxt-frontend/node_modules/pinia-plugin-persistedstate/dist/nuxt/runtime/plugin.js";
import plugin_t2GMTTFnMT from "/home/binaffan.com/nuxt-frontend/node_modules/@nuxtjs/device/dist/runtime/plugin.mjs";
import slideovers_LDumGYo2KH from "/home/binaffan.com/nuxt-frontend/node_modules/@nuxt/ui/dist/runtime/plugins/slideovers.mjs";
import modals_bidRKewKK5 from "/home/binaffan.com/nuxt-frontend/node_modules/@nuxt/ui/dist/runtime/plugins/modals.mjs";
import colors_244lXBzhnM from "/home/binaffan.com/nuxt-frontend/node_modules/@nuxt/ui/dist/runtime/plugins/colors.mjs";
import plugin_client_OVoKJro5pc from "/home/binaffan.com/nuxt-frontend/node_modules/@nuxtjs/color-mode/dist/runtime/plugin.client.js";
import plugin_I4dbrL2rYz from "/home/binaffan.com/nuxt-frontend/node_modules/@sidebase/nuxt-auth/dist/runtime/plugin.js";
import yup_unique_6fIsyqzpnh from "/home/binaffan.com/nuxt-frontend/plugins/yup-unique.js";
import highlight_aQYcbKVmr3 from "/home/binaffan.com/nuxt-frontend/plugins/highlight.js";
import mainState_wd8zZxoShp from "/home/binaffan.com/nuxt-frontend/plugins/mainState.js";
import runtime_error_FzSu5D7Pye from "/home/binaffan.com/nuxt-frontend/plugins/runtime-error.js";
import slugify_client_bi4ee7jQjn from "/home/binaffan.com/nuxt-frontend/plugins/slugify.client.ts";
export default [
  revive_payload_client_4sVQNw7RlN,
  unhead_KgADcZ0jPj,
  router_jmwsqit4Rs,
  payload_client_yVLowv6hDl,
  navigation_repaint_client_bs2bWDGRIE,
  check_outdated_build_client_8vK7RkfGxZ,
  chunk_reload_client_UciE0i6zes,
  plugin_vue3_YdLad5Mpq3,
  components_plugin_KR1HBZs4kY,
  prefetch_client_5tzzN0oIVL,
  plugin_PSbK9A48ZQ,
  plugin_t2GMTTFnMT,
  slideovers_LDumGYo2KH,
  modals_bidRKewKK5,
  colors_244lXBzhnM,
  plugin_client_OVoKJro5pc,
  plugin_I4dbrL2rYz,
  yup_unique_6fIsyqzpnh,
  highlight_aQYcbKVmr3,
  mainState_wd8zZxoShp,
  runtime_error_FzSu5D7Pye,
  slugify_client_bi4ee7jQjn
]